import { atomWithToggleAndStorage } from './utils';

export const alphaToggleAtom = atomWithToggleAndStorage('alphaToggle', false);
alphaToggleAtom.debugLabel = 'alphaToggle';

export default { alphaToggleAtom };
